export default __webpack_public_path__ + "static/media/complementary--steep-descent--g1.8c7f6ee5.png";